"use client";

import Link from "next/link";
import Image from "next/image";
import { motion } from "motion/react";
import { ArrowRight2 } from "@/components/icons/ArrowRight2";
import {
  arrowVariants,
  financingContainerVariants,
  financingCardVariants,
  slideUpVariants,
} from "@/lib/animations";
import { financingItems } from "../data";

export function Financing() {
  return (
    <section className="py-10 md:py-16 lg:py-20 2xl:py-28">
      <div className="px-5 md:px-6 lg:px-10">
        <div className="mx-auto mb-10 max-w-8xl md:mb-12 lg:mb-16 2xl:mb-20">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={slideUpVariants}
            className="max-w-md text-2xl font-medium tracking-copy sm:text-3xl md:text-4xl lg:max-w-xl lg:text-5xl lg:leading-[1.18]"
          >
            Flexible financing for devices that matter to you
          </motion.h2>
        </div>
      </div>

      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
        variants={financingContainerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {financingItems.map((item, index) => (
          <motion.div
            key={item.title}
            variants={financingCardVariants}
            className="group"
          >
            <motion.div
              initial="initial"
              whileHover="hover"
              className={`relative h-[460px] w-full overflow-hidden bg-white p-5 transition-colors duration-500 xl:h-[540px] xl:py-8 ${
                index % 2 === 0
                  ? "group-hover:bg-green-500"
                  : "group-hover:bg-blue-100"
              }`}
            >
              <h3 className="relative z-10 text-center text-xl font-medium text-black-400 md:text-2xl xl:text-[28px]">
                {item.title}
              </h3>

              <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
                <div className="relative h-full w-full">
                  <Image
                    src={item.imageUrl}
                    alt={item.title}
                    fill
                    className="object-contain p-8"
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 25vw"
                  />
                </div>
              </div>

              <motion.div
                initial="initial"
                whileHover="hover"
                className="absolute bottom-5 flex w-full items-center justify-center"
              >
                <Link
                  href="https://wa.link/428o4f"
                  target="_blank"
                  className="flex items-center gap-2 text-lg font-medium text-green-600 transition-colors duration-300 group-hover:text-black md:text-xl"
                >
                  <span>{item.cta}</span>
                  <motion.span
                    variants={arrowVariants}
                    className="opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                  >
                    <ArrowRight2 />
                  </motion.span>
                </Link>
              </motion.div>
            </motion.div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
